import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Certificate, DownloadSimple, ShieldCheck } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function MyCertificates() {
  const [certs, setCerts] = useState([]);
  useEffect(() => { api.get("/certificates").then((r) => setCerts(r.data)).catch(() => {}); }, []);
  const fmt = (d) => new Date(d).toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" });

  return (
    <div>
      <h1 className="font-display text-3xl font-800 tracking-tight mb-1">Mis Certificados</h1>
      <p className="text-muted-foreground mb-8">Descarga tus certificados o compártelos para verificación.</p>
      {certs.length === 0 ? (
        <div className="bg-white border border-border rounded-lg p-12 text-center" data-testid="certs-empty">
          <Certificate size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">Aún no tienes certificados. Aprueba un curso para obtenerlos.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {certs.map((c) => (
            <div key={c.folio} className="bg-white border border-border rounded-lg p-6 flex flex-col sm:flex-row sm:items-center gap-4"
              data-testid={`cert-${c.folio}`}>
              <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                <Certificate size={26} className="text-primary" weight="duotone" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display font-700 tracking-tight">{c.course_name}</h3>
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground mt-1">
                  <span className="font-mono">{c.folio}</span>
                  <span>Nota {c.grade}</span>
                  <span>{c.hours}h</span>
                  <span>{fmt(c.issued_at)}</span>
                </div>
              </div>
              <a href={`${API}/certificates/${c.folio}/download`} target="_blank" rel="noreferrer" data-testid={`cert-download-${c.folio}`}>
                <Button className="bg-primary hover:bg-blue-600 text-white gap-2 w-full sm:w-auto">
                  <DownloadSimple size={18} /> Descargar PDF
                </Button>
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
